/*
 *
 * FormBuilder actions
 *
 */

import { generateTempFieldId } from 'utils/idUtils';

import {
  ADD_FIELD,
  ADD_STEP,
  BULK_TOGGLE_DROPDOWN_OPTIONS,
  CHANGE_CONSENT_STYLE,
  FIELD_CLICKED,
  CLEAR_FORM,
  COLLAPSE_ALL_FIELDS,
  DELETE_FIELD,
  EXPAND_ALL_FIELDS,
  FIELD_VALIDITY_CHANGED,
  LOAD_IN_PROGRESS,
  RECEIVE_SF_FIELD_DATA,
  REINITIALIZE_FIELD_VALIDITY,
  REMOVE_STEP,
  REORDER_FIELD,
  SAVE_IN_PROGRESS,
  SET_ACTIVE_FIELD,
  SET_AVAILABLE_CREDENTIAL_TYPES,
  SET_AVAILABLE_PROGRAMS,
  SET_AVAILABLE_PROGRAMS_OF_STUDY,
  SET_DIRTY,
  SET_FIELD_INFERRED_STATE,
  SET_FORM,
  SET_PROGRAM_FOR_FORM,
  SET_SUPPORTS_DEGREE_OFFERING,
  SHOW_FORM_ERRORS,
  REMOVE_ALL_USER_BRANCH_MEMBERSHIP,
  TOGGLE_BRANCH_MEMBERSHIP,
  TOGGLE_BRANCHING,
  TOGGLE_FIELD_COLLAPSED_STATE,
  UPDATE_FIELD_OVERRIDE_STATE,
  UPDATE_FIELD_NAME,
  UPDATE_FORM_VALUE,
  UPDATE_FIELD_CONDITIONALITY,
  UPDATE_FORM_VALIDITY,
  UPDATE_UI_STATE,
  REORDER_DROPDOWN,
  UPDATE_DEFAULT_DEGREE_OFFERING,
  UPDATE_PROGRAM_OF_STUDY,
  TOGGLE_THANK_YOU_ROUTING,
  SET_THANK_YOU_ROUTING, REFRESH_THANK_YOU_ROUTING,
} from './constants';

export function addField(id = generateTempFieldId(), index) {
  return {
    type: ADD_FIELD,
    id,
    index,
  };
}

export function addStep(id = generateTempFieldId()) {
  return {
    type: ADD_STEP,
    id,
  };
}

export function bulkToggleDropdownOptions(id, dropdownOptions, value) {
  return {
    type: BULK_TOGGLE_DROPDOWN_OPTIONS,
    id,
    dropdownOptions,
    value,
  };
}

export function fieldClicked(fieldId) {
  return {
    type: FIELD_CLICKED,
    fieldId,
  };
}

export function changeConsentStyle(consentStyle) {
  return {
    type: CHANGE_CONSENT_STYLE,
    consentStyle,
  };
}

export function clearForm(credentialType) {
  return {
    type: CLEAR_FORM,
    credentialType,
  };
}

export function collapseAllFields() {
  return {
    type: COLLAPSE_ALL_FIELDS,
  };
}

export function deleteField(keyPath) {
  return {
    type: DELETE_FIELD,
    keyPath,
  };
}

export function expandAllFields() {
  return {
    type: EXPAND_ALL_FIELDS,
  };
}

export function fieldValidityChanged(keyPath, isValid, errorText, replaceError) {
  return {
    type: FIELD_VALIDITY_CHANGED,
    keyPath,
    isValid,
    errorText,
    replaceError,
  };
}

export function loadInProgress(inProgress) {
  return {
    type: LOAD_IN_PROGRESS,
    inProgress,
  };
}

export function receiveSfFieldData(sfFieldData, fieldNameDropdownOpts) {
  return {
    type: RECEIVE_SF_FIELD_DATA,
    sfFieldData,
    fieldNameDropdownOpts,
  };
}

export function reInitializeFieldValidity(keyPath, newValidity) {
  return {
    type: REINITIALIZE_FIELD_VALIDITY,
    keyPath,
    newValidity,
  };
}

export function removeAllUserBranchMembership(fieldId) {
  return {
    type: REMOVE_ALL_USER_BRANCH_MEMBERSHIP,
    fieldId,
  };
}

export function removeStep(id) {
  return {
    type: REMOVE_STEP,
    id,
  };
}

export function reorderDropdown(keyPath, optionId, direction) {
  return {
    type: REORDER_DROPDOWN,
    keyPath,
    optionId,
    direction,
  };
}

export function reorderField(source, target) {
  return {
    type: REORDER_FIELD,
    source,
    target,
  };
}

export function saveInProgress(inProgress) {
  return {
    type: SAVE_IN_PROGRESS,
    inProgress,
  };
}

export function setAvailableCredentialTypes(credentialTypes) {
  const availableCredentialTypes = credentialTypes.map(({ id, value, displayName }) => ({ id, value, displayName }));
  return {
    type: SET_AVAILABLE_CREDENTIAL_TYPES,
    availableCredentialTypes,
  };
}

export function setAvailablePrograms(programs) {
  return {
    type: SET_AVAILABLE_PROGRAMS,
    programs,
  };
}

export function setAvailableProgramsOfStudy(programsOfStudy) {
  return {
    type: SET_AVAILABLE_PROGRAMS_OF_STUDY,
    programsOfStudy,
  };
}

export function setActiveField(fieldId) {
  return {
    type: SET_ACTIVE_FIELD,
    fieldId,
  };
}

export function setFieldInferredState(fieldName, value, fieldId) {
  return {
    type: SET_FIELD_INFERRED_STATE,
    fieldName,
    value,
    fieldId,
  };
}

export function setSupportsDegreeOffering(hasDegreeOffering) {
  return {
    type: SET_SUPPORTS_DEGREE_OFFERING,
    hasDegreeOffering,
  };
}

export function showFormErrors() {
  return {
    type: SHOW_FORM_ERRORS,
  };
}

export function setDirty(isDirty) {
  return {
    type: SET_DIRTY,
    isDirty,
  };
}

export function setForm(form, { shouldRebuildCollapsedState = false } = {}) {
  return {
    type: SET_FORM,
    form,
    shouldRebuildCollapsedState,
  };
}

export function setProgramDataForForm(program) {
  return {
    type: SET_PROGRAM_FOR_FORM,
    program,
  };
}

export function toggleBranchMembership(fieldId, answerValue, branchMemberId) {
  return {
    type: TOGGLE_BRANCH_MEMBERSHIP,
    fieldId,
    answerValue,
    branchMemberId,
  };
}

export function toggleBranching(fieldId) {
  return {
    type: TOGGLE_BRANCHING,
    fieldId,
  };
}

export function toggleThankYouRoute(fieldId) {
  return {
    type: TOGGLE_THANK_YOU_ROUTING,
    fieldId,
  };
}

export function setThankYouRoute(fieldId, answer, url) {
  return {
    type: SET_THANK_YOU_ROUTING,
    fieldId,
    answer,
    url,
  };
}

export function refreshThankYouRoute(fieldId) {
  return {
    type: REFRESH_THANK_YOU_ROUTING,
    fieldId,
  };
}

export function toggleFieldCollapsedState(index) {
  return {
    type: TOGGLE_FIELD_COLLAPSED_STATE,
    index,
  };
}

export function updateDefaultDegreeOffering({ degreeOffering, programFullName, programId, programOffering, salesforceOrg }) {
  return {
    type: UPDATE_DEFAULT_DEGREE_OFFERING,
    data: { degreeOffering, programFullName, programId, programOffering, salesforceOrg },
  };
}

export function updateFieldName(keyPath, incomingFieldName) {
  return {
    type: UPDATE_FIELD_NAME,
    keyPath,
    incomingFieldName,
  };
}

export function updateFormValue(keyPath, value, shouldMakeDirty = true) {
  return {
    type: UPDATE_FORM_VALUE,
    keyPath,
    value,
    shouldMakeDirty,
  };
}

export function updateFieldConditionality(keyPath, newFieldName, previousFieldName) {
  return {
    type: UPDATE_FIELD_CONDITIONALITY,
    keyPath,
    newFieldName,
    previousFieldName,
  };
}

export function updateFieldOverrideState(fieldId, fieldType, consentStyle) {
  return {
    type: UPDATE_FIELD_OVERRIDE_STATE,
    fieldId,
    fieldType,
    consentStyle,
  };
}

export function updateFormValidity(keyPath, isValid, errorText, replaceError = false) {
  return {
    type: UPDATE_FORM_VALIDITY,
    keyPath,
    isValid,
    errorText,
    replaceError,
  };
}

export function updateUIState(keyPath, value) {
  return {
    type: UPDATE_UI_STATE,
    keyPath,
    value,
  };
}

export function updateProgramOfStudy({ id, centralParkUUID, publicAlias, credential_type_id }) {
  return {
    type: UPDATE_PROGRAM_OF_STUDY,
    data: { id, centralParkUUID, publicAlias, credential_type_id },
  };
}
